import { createBrowserHistory } from 'history';
import env from '../env';
import { joinPath } from '../utils';
import { getLanguage } from '../selectors/userSelectors';

export default createBrowserHistory({
  basename: joinPath(`/${getLanguage()}`, env.BASE_NAME),
});
